import { defaultTheme, mergeTheme } from 'evergreen-ui'

const customTheme = mergeTheme(defaultTheme, {
  components: {
    Dialog: {
      baseStyle: {
        overlay: {
          backgroundColor: 'rgba(67, 90, 111, 0.7)',
          backdropFilter: 'blur(4px)',
        }
      },
      sizes: {
        default: {
          width: '560px',
          height: 'auto'
        }
      }
    },
    DialogHeader: {
      baseStyle: {
        backgroundColor: 'var(--darkgreen)',
        color: '#fff',
        paddingX: 16,
        paddingY: 16,
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        '& h4': {
          color: '#fff'
        }
      }
    },
    Heading: {
      variants: {
        dialogHeader: {
          color: '#fff'
        }
      }
    },
    DialogBody: {
      baseStyle: {
        padding: 24,
        color: '#5e5e5e'
      }
    },
    DialogFooter: {
      baseStyle: {
        padding: 16,
        borderTop: '1px solid var(--lightgrey)'
      }
    },
    SideSheet: {
      baseStyle: {
        backgroundColor: 'var(--maroon-dark)'
      }
    },
    Button: {
      appearances: {
        dialogConfirm: {
          backgroundColor: 'var(--darkgreen)',
          color: 'white',
          _hover: {
            backgroundColor: 'var(--darkgreen-dark)'
          },
          _active: {
            backgroundColor: 'var(--darkgreen-dark)'
          },
          _focus: {
            boxShadow: '0 0 0 2px var(--darkgreen-light)'
          }
        },
        dialogCancel: {
          backgroundColor: 'white',
          color: 'var(--maroon)',
          borderColor: 'var(--maroon)',
          _hover: {
            backgroundColor: 'var(--maroon-light)'
          },
          _active: {
            backgroundColor: 'var(--maroon-light)'
          },
          _focus: {
            boxShadow: '0 0 0 2px var(--maroon-light)'
          }
        }
      }
    }
  }
})

console.log('Theme being loaded:', customTheme)

export default customTheme
